import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: { currentTable: string; isCalendarVisible: boolean; currentTableId: string } = {
    currentTable: "tax-bill-personal",
    currentTableId: "",
    isCalendarVisible: false,
};

const tableSlice = createSlice({
    name: "table",
    initialState,
    reducers: {
        updateTable: (state, action: PayloadAction<string>) => {
            state.currentTable = action.payload;
        },
        updateCurrenTableId: (state, action: PayloadAction<string>) => {
            state.currentTableId = action.payload;
        },
        setCalendarTable: (state, action: PayloadAction<boolean>) => {
            state.isCalendarVisible = action.payload;
        },
    },
});

export const { updateTable, setCalendarTable, updateCurrenTableId } = tableSlice.actions;

export const tableReducer = tableSlice.reducer;
export default tableSlice.reducer;
